import { call, put, fork, take } from 'redux-saga/effects'
import { takeEvery } from 'redux-saga'
import { replace } from 'react-router-redux'

import * as fromAuth from '@src/redux/modules/auth'
import * as fromUser from '@src/redux/modules/user'
import { auth } from '@src/services/api'
import { setAuthToken, removeAuthToken } from 'utils/auth'
import { analytics } from '@src/services/Analytics'

// /////////////////////////////////////////////////////////////////////////////
// Sagas
// /////////////////////////////////////////////////////////////////////////////
export function * logout (action) {
  yield call(removeAuthToken)
  window.location = '/logout'
}

export function * login (action) {
  yield put({
    type: fromAuth.LOGIN_STARTED
  })

  const {
    payload: {
      email,
      password
    },
    meta: {
      next = '/'
    }
  } = action

  const credentials = {
    email,
    password
  }

  const { response, error } = yield call(auth.login, credentials)
  if (error) {
    return yield put({
      type: fromAuth.LOGIN_FAILURE,
      payload: error,
      error: true
    })
  }

  yield call(setAuthToken, response.jwt)

  yield put({
    type: fromAuth.LOGIN_SUCCESS,
    payload: response
  })

  yield take(fromUser.FETCH_SUCCESS)

  yield put(replace(next))

  yield fork([analytics, analytics.login], {
    userId: response.userId,
    email
  })
}

export function * fbLogin (action) {
  yield put({
    type: fromAuth.LOGIN_STARTED
  })

  const { response, error } = yield call(auth.fbLogin, action.payload)
  if (error) {
    return yield put({
      type: fromAuth.LOGIN_FAILURE,
      payload: error,
      error: true
    })
  }

  yield call(setAuthToken, response.jwt)

  yield put({
    type: fromAuth.LOGIN_SUCCESS,
    payload: response
  })

  yield put(replace('/'))
}

export function * signup (action) {
  yield put({
    type: fromAuth.SIGNUP_STARTED
  })

  const {
    payload: {
      firstName,
      lastName,
      email,
      password,
      passwordConfirmation
    },
    meta: {
      next = '/'
    }
  } = action

  const userData = {
    firstName,
    lastName,
    email,
    password,
    passwordConfirmation
  }

  const { response, error } = yield call(auth.signup, userData)

  if (error) {
    return yield put({
      type: fromAuth.SIGNUP_FAILURE,
      payload: error,
      error: true
    })
  }

  yield call(setAuthToken, response.jwt)

  yield put({
    type: fromAuth.SIGNUP_SUCCESS,
    payload: response
  })

  yield put(replace(next))

  yield fork([analytics, analytics.signup], {
    userId: response.userId,
    firstName,
    lastName,
    email
  })
}

// /////////////////////////////////////////////////////////////////////////////
// Watchers
// /////////////////////////////////////////////////////////////////////////////
export function * watchLogoutSaga () {
  yield fork(takeEvery, fromAuth.LOGOUT, logout)
}

export function * watchLoginSaga () {
  yield fork(takeEvery, fromAuth.LOGIN, login)
}

export function * watchFBLoginSaga () {
  yield fork(takeEvery, fromAuth.FB_LOGIN, fbLogin)
}

export function * watchSignupSaga () {
  yield fork(takeEvery, fromAuth.SIGNUP, signup)
}

// /////////////////////////////////////////////////////////////////////////////
// Root Saga
// /////////////////////////////////////////////////////////////////////////////
export default function * rootSaga () {
  yield * [
    fork(watchLogoutSaga),
    fork(watchLoginSaga),
    fork(watchFBLoginSaga),
    fork(watchSignupSaga)
  ]
}



// WEBPACK FOOTER //
// ./src/redux/sagas/auth.js